import * as React from "react";
import { Dispatch, SetStateAction } from "react";
import { FormComponentProps } from "antd/lib/form";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { EditTradeOwner } from "./EditTradeOwner/EditTradeOwner";
import { EditTradeSpouse } from "./EditTradeSpouse/EditTradeSpouse";
import { userHaveSpouse } from "src/util/Validations";
import { EditTradeBankInfo } from './EditBankInfo/EditTradeBankInfo';
import { EditTradeAddress } from './EditAddress/EditTradeAddress';

interface IEditTradeView extends FormComponentProps {
  loading: boolean;
  showBankInfo?: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  isMotherNameRequired?: boolean;
  isCivilStatusRequired?: boolean;
  isProfessionRequired?: boolean;
  isFatherNameRequired?: boolean;
  isTradeSpouseRequired?: boolean;
  isIssuingAuthorityRequired?: boolean;
  isRGDateRequired?: boolean;
}

export const TradeEditView: React.FC<IEditTradeView> = ({
  loading,
  showBankInfo,
  setLoading,
  trade,
  setTrade,
  form,
  isMotherNameRequired,
  isTradeSpouseRequired,
  isCivilStatusRequired,
  isProfessionRequired,
  isFatherNameRequired,
  isIssuingAuthorityRequired,
  isRGDateRequired
}) => {
  return (
    <>
      <EditTradeOwner
        form={form}
        setLoading={setLoading}
        trade={trade}
        setTrade={setTrade}
        title="Dados do Proprietário"
        isMotherNameRequired={isMotherNameRequired}
        isCivilStatusRequired={isCivilStatusRequired}
        isProfessionRequired={isProfessionRequired}
        isFatherNameRequired={isFatherNameRequired}
        isRGDateRequired={isRGDateRequired}
        isIssuingAuthorityRequired={isIssuingAuthorityRequired}
      />
      {userHaveSpouse(trade) && (
        <EditTradeSpouse
          form={form}
          loading={loading}
          setLoading={setLoading}
          trade={trade}
          setTrade={setTrade}
          title="Dados do Cônjuge"
          isTradeSpouseRequired={isTradeSpouseRequired}
          isRGDateRequired={isRGDateRequired}
          isIssuingAuthorityRequired={isIssuingAuthorityRequired}
        />
      )}
      {showBankInfo && <EditTradeBankInfo form={form} trade={trade} setTrade={setTrade} title="Dados Bancários" isBankInfoRequired />}
      <EditTradeAddress form={form} trade={trade} setTrade={setTrade} title="Endereço" />
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/TradeEditView.tsx